import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
import { ContentOrderedListItem } from "./content-ordered-list-item";
export var CONTENT_ORDERED_LIST_DEFAULTS = {
  types: ["lower-alpha", "lower-roman", "upper-alpha", "upper-roman"]
};
export var ContentOrderedList = Object.assign(forwardRefAs(function (_a, ref) {
  var className = _a.className,
      type = _a.type,
      rest = tslib_1.__rest(_a, ["className", "type"]);

  return React.createElement(Generic, Object.assign({
    className: classNames(_defineProperty({}, "is-".concat(type), type), className),
    ref: ref
  }, rest));
}, {
  as: "ol"
}), {
  Item: ContentOrderedListItem
});
ContentOrderedList.displayName = "Content.OrderedList";